import React from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';

const Layout = (props: any) =>  {

    return (
        <div className='layout'>
            <NavMenu/>
        <Container>
          {props.children}
        </Container>
      </div>
    );
}

export default Layout;